(function () {

  function init() {
    //waitForDOM(initBadge);
    waitForDOM(() => {
      if (document.querySelector('#reviewsio-carousel-widget')) {
        var skus = document.querySelector('#reviewsio-carousel-widget').getAttribute('data-sku');
        initWidget(skus);
      }
      if (document.querySelector('#reviewsio-polaris-widget')) {
        var skus = document.querySelector('#reviewsio-polaris-widget').getAttribute('data-sku');
        initPolarisWidget(skus);
      }
    })
    initStars();
  }

  function initBadge() {
    var badge = document.createElement('div');
    badge.id = 'reviews-io-floating-widget';
    badge.setAttribute('widget-id', 'KOjA9sgZH5w2tMaW');
    badge.setAttribute('store-name', 'www.sternglas.de');
    badge.lang = 'de';
    document.body.append(badge);
    loadScript('//widget.reviews.io/modern-widgets/floating.js');
  }

  function initStars() {
    // We need a more complex logic because we need to load stars in sections that are loaded later
    // E.g. recommendations section that is loaded only when it is scrolled into view
    // or the when a next page is loaded on a collection page.
    var starsScriptLoaded = false;
    var messagesThatTriggerLoadStars = ['product_recommendations_loaded', 'next_page_loaded'];

    window.addEventListener('message', onLoadStarsMessages.bind(this))
    waitForDOM(() => {
      if (document.querySelector('.reviews-io_stars')) {
        loadStarsScript();
      }
    })

    function onLoadStarsMessages(event) {
      if (!event.data || !messagesThatTriggerLoadStars.includes(event.data.type)) return
      if (starsScriptLoaded) {
        loadStars();
      } else {
        loadStarsScript();
      }
    }
    function loadStarsScript(el) {
      loadScript('https://widget.reviews.io/product/dist.js', function () {
        loadScript('https://widget.reviews.io/rating-snippet/dist.js', function () {
          starsScriptLoaded = true;
          loadStars();
        });
      });
      loadStyle('https://widget.reviews.io/rating-snippet/dist.css');
    }
    function loadStars() {
      ratingSnippet('ruk_rating_snippet_detail', {
        store: "www.sternglas.de",
        color: "#EB9B23",
        linebreak: false,
        snippetPopup: false,
        mode: 'extended',
      });
      ratingSnippet('ruk_rating_snippet', {
        store: "www.sternglas.de",
        color: "#EB9B23",
        linebreak: false,
        snippetPopup: true,
      });
    }
  }

  function initWidget(skus) {
    loadStyle('https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2022060112');
    loadStyle('https://assets.reviews.io/iconfont/reviewsio-icons/style.css?_t=2022060112');
    loadScript('https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2022060112', function () {
      createCarouselWidget(skus);
    });
  }


  function initPolarisWidget(skus) {
    loadStyle('https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2022060112');
    loadStyle('https://assets.reviews.io/iconfont/reviewsio-icons/style.css?_t=2022060112');
    loadScript('https://widget.reviews.io/polaris/build.js', function () {
      createPolarisWidget(skus);
    });
  }

  function waitForDOM(callback) {
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', () => {
        callback();
      })
    } else {
      callback();
    }
  }

  init();

  function createCarouselWidget(skus) {
    new carouselInlineWidget('reviewsio-carousel-widget', {
      store: 'www.sternglas.de',
      sku: skus,
      lang: 'de',
      carousel_type: 'topHeader',
      styles_carousel: 'CarouselWidget--topHeader',
      options: {
        general: {
          review_type: 'product', // Available options: company, product, third_party. You can choose one type or multiple separated by comma.
          min_reviews: '3', // Minimum number of reviews required for widget to be displayed
          max_reviews: '20',
          address_format: 'CITY, COUNTRY',
          enable_auto_scroll: 10000, // Carousel auto-scrolling speed. 3000 = 3 seconds. If you want to disable auto-scroll, set this value to false.
        },
        header: {
          enable_overall_stars: true,
          rating_decimal_places: 2,
        },
        reviews: {
          enable_customer_name: true,
          enable_customer_location: true,
          enable_verified_badge: true,
          enable_recommends_badge: true,
          enable_photos: true,
          enable_videos: true,
          enable_review_date: true,
          disable_same_customer: true, // Hide reviews written by the same customer (This may occur when customer reviews multiple products)
          min_review_percent: 4, // Minimum star rating
          third_party_source: true, // Show 3rd party review source
          hide_empty_reviews: true,
          enable_product_name: true,
          tags: "", // Show only reviews which have specific tags (multiple semicolon separated tags allowed i.e tag1;tag2)
          branch: "", // Show branch, only one input
          enable_branch_name: false,
        },
        popups: {
          enable_review_popups:  true,
          enable_helpful_buttons: true,
          enable_helpful_count: true,
          enable_share_buttons: true,
        },
      },
      translations: {
        verified_customer:  "Verified Customer",
      },
      styles:{
        /*Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.*/
        '--base-font-size': '16px',
        '--base-maxwidth':'100%',
        /*Logo styles:*/
        '--reviewsio-logo-style':'var(--logo-normal)',
        /*Star styles:*/
        '--common-star-color':'#eb9b23',
        '--common-star-disabled-color':' rgba(0,0,0,0.25)',
        '--medium-star-size':' 22px',
        '--small-star-size':'19px', /*Modal*/
        '--x-small-star-size':'16px',
        '--x-small-star-display':'inline-flex',
        /*Header styles:*/
        '--header-order':'1',
        '--header-width':'160px',
        '--header-bg-start-color':'transparent',
        '--header-bg-end-color':'transparent',
        '--header-gradient-direction':'135deg',
        '--header-padding':'0.5em',
        '--header-border-width':'0px',
        '--header-border-color':'rgba(0,0,0,0.1)',
        '--header-border-radius':'0px',
        '--header-shadow-size':'0px',
        '--header-shadow-color':'rgba(0, 0, 0, 0.1)',
        /*Header content styles:*/
        '--header-star-color':'#eb9b23',
        '--header-disabled-star-color':'inherit',
        '--header-heading-text-color':'inherit',
        '--header-heading-font-size':'inherit',
        '--header-heading-font-weight':'inherit',
        '--header-heading-line-height':'inherit',
        '--header-heading-text-transform':'inherit',
        '--header-subheading-text-color':'inherit',
        '--header-subheading-font-size':'inherit',
        '--header-subheading-font-weight':'inherit',
        '--header-subheading-line-height':'inherit',
        '--header-subheading-text-transform':'inherit',
        /*Review item styles:*/
        '--item-maximum-columns':'5',/*Must be 3 or larger*/
        '--item-background-start-color':'transparent',
        '--item-background-end-color':'transparent',
        '--item-gradient-direction':'135deg',
        '--item-padding':'0.5em',
        '--item-border-width':'0px',
        '--item-border-color':'rgba(0,0,0,0.1)',
        '--item-border-radius':'0px',
        '--item-shadow-size':'0px',
        '--item-shadow-color':'rgba(0,0,0,0.1)',
        /*Heading styles:*/
        '--heading-text-color':' #0E1311',
        '--heading-text-font-weight':' 600',
        '--heading-text-font-family':' inherit',
        '--heading-text-line-height':' 1.4',
        '--heading-text-letter-spacing':'0',
        '--heading-text-transform':'none',
        /*Body text styles:*/
        '--body-text-color':' #0E1311',
        '--body-text-font-weight':'400',
        '--body-text-font-family':' inherit',
        '--body-text-line-height':' 1.4',
        '--body-text-letter-spacing':'0',
        '--body-text-transform':'none',
        /*Scroll button styles:*/
        '--scroll-button-icon-color':'#0E1311',
        '--scroll-button-icon-size':'24px',
        '--scroll-button-bg-color':'transparent',
        '--scroll-button-border-width':'0px',
        '--scroll-button-border-color':'rgba(0,0,0,0.1)',
        '--scroll-button-border-radius':'60px',
        '--scroll-button-shadow-size':'0px',
        '--scroll-button-shadow-color':'rgba(0,0,0,0.1)',
        '--scroll-button-horizontal-position':'0px',
        '--scroll-button-vertical-position':'0px',
        /*Badge styles:*/
        '--badge-icon-color':'#0E1311',
        '--badge-icon-font-size':'15px',
        '--badge-text-color':'#0E1311',
        '--badge-text-font-size':'inherit',
        '--badge-text-letter-spacing':'inherit',
        '--badge-text-transform':'inherit',
        /*Author styles:*/
        '--author-font-size':'inherit',
        '--author-font-weight':'inherit',
        '--author-text-transform':'inherit',
        /*Product photo or review photo styles:*/
        '--photo-video-thumbnail-size':'60px',
        '--photo-video-thumbnail-border-radius':'0px',
        /*Popup styles:*/
        '--popup-backdrop-color':'rgba(0,0,0,0.75)',
        '--popup-color':'#ffffff',
        '--popup-star-color':'inherit',
        '--popup-disabled-star-color':'inherit',
        '--popup-heading-text-color':'inherit',
        '--popup-body-text-color':'inherit',
        '--popup-badge-icon-color':'inherit',
        '--popup-badge-icon-font-size':'19px',
        '--popup-badge-text-color':'inherit',
        '--popup-badge-text-font-size':'14px',
        '--popup-border-width':'0px',
        '--popup-border-color':'rgba(0,0,0,0.1)',
        '--popup-border-radius':'0px',
        '--popup-shadow-size':'0px',
        '--popup-shadow-color':'rgba(0,0,0,0.1)',
        '--popup-icon-color':'#0E1311',
        /*Tooltip styles:*/
        '--tooltip-bg-color':'#0E1311',
        '--tooltip-text-color':'#ffffff',
      },
    });
  }
  function createPolarisWidget(skus) {
    new ReviewsWidget("#reviewsio-polaris-widget", {
      //Your REVIEWS.io Store ID and widget type:
      store: "www.sternglas.de",
      widget: "polaris",
      //Content settings (store_review,product_review,third_party_review,questions). Choose what to display in this widget:
      options: {
          types: "product_review",
          lang: "de",
          //Possible layout options: bordered, large and reverse.
          layout: "",
          //How many reviews & questions to show per page?
          per_page: 3,
          store_review:{
            hide_if_no_results: false,
          },
          third_party_review:{
            hide_if_no_results: false,
          },
          //Product specific settings. Provide product SKU for which reviews should be displayed:
          product_review:{
              //Display product reviews - include multiple product SKUs seperated by Semi-Colons (Main Indentifer in your product catalog )
              sku: skus,
              hide_if_no_results: false,
          },
          //Questions settings:
          questions:{
              hide_if_no_results: false,
              enable_ask_question: true,
              show_dates: true,
              //Display group questions by providing a grouping variable, new questions will be assigned to this group.
              grouping:"[Group questions by providing a grouping variable here or a specific product SKU]"
          },
          //Header settings:
          header:{
              enable_summary: true, //Show overall rating & review count
              enable_ratings: true,
              enable_attributes: true,
              enable_image_gallery: true, //Show photo & video gallery
              enable_percent_recommended: false, //Show what percentage of reviewers recommend it
              enable_write_review: true, //Show “Write Review” button
              enable_ask_question: true, //Show “Ask Question” button
              enable_sub_header: true, //Show subheader
              rating_decimal_places: 2,
              use_write_review_button:  false, //Show “be the first to leave a review” text as a button
          },
          //Filtering settings:
          filtering:{
              enable: true, //Show filtering options
              enable_text_search: true, //Show search field
              enable_sorting: true, //Show sorting options (most recent, most popular)
              enable_product_filter: false, //Show product options filter
              enable_media_filter: true, //Show reviews with images/video/media options
              enable_overall_rating_filter: true, //Show overall rating breakdown filter
              enable_language_filter: false, // Filter by review language
              enable_language_filter_language_change: false, // Update widget language based on language selected
              enable_ratings_filters: true, //Show product attributes filter
              enable_attributes_filters: true, //Show author attributes filter
          },
          //Review settings:
          reviews:{
              enable_avatar: true, //Show author avatar
              enable_reviewer_name:  true, //Show author name
              enable_reviewer_address:  true, //Show author location
              reviewer_address_format: "city, country", //Author location display format
              enable_verified_badge: true, //Show “Verified Customer” badge
              enable_subscriber_badge: true, //Show “Verified Subscriber” badge
              review_content_filter: "undefined", //Filter content
              enable_reviewer_recommends: true, //Show “I recommend it” badge
              enable_attributes: true, //Show author attributes
              enable_product_name: true, //Show display product name
              enable_review_title: undefined, //Show review title
              enable_replies: true, //Show review replies
              enable_images: true, //Show display review photos
              enable_ratings: true, //Show product attributes (additional ratings)
              enable_share: true, //Show share buttons
              enable_helpful_vote: true, //Show “was this helpful?” section
              enable_helpful_display: true, //Show how many times times review upvoted
              enable_report: true, //Show report button
              enable_date: true, //Show when review was published
              enable_third_party_source: true, // Show third party source
          },
      },
      //Translation settings
      translations: {
          "Verified Customer": "Verified Customer"
      },
      //Style settings:
      styles: {
          //Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
          "--base-font-size": "16px",
          //Button styles (shared between buttons):
          "--common-button-font-family": "inherit",
          "--common-button-font-size":"16px",
          "--common-button-font-weight":"500",
          "--common-button-letter-spacing":"0",
          "--common-button-text-transform":"none",
          "--common-button-vertical-padding":"10px",
          "--common-button-horizontal-padding":"20px",
          "--common-button-border-width":"2px",
          "--common-button-border-radius":"0px",
          //Primary button styles:
          "--primary-button-bg-color": "#0E1311",
          "--primary-button-border-color": "#0E1311",
          "--primary-button-text-color": "#FFFFFF",
          //Secondary button styles:
          "--secondary-button-bg-color": "transparent",
          "--secondary-button-border-color": "#0E1311",
          "--secondary-button-text-color": "#0E1311",
          //Star styles:
          "--common-star-color": "#EB9B23",
          "--common-star-disabled-color": "rgba(0,0,0,0.25)",
          "--medium-star-size": "22px",
          "--small-star-size": "19px",
          //Heading styles:
          "--heading-text-color": "#0E1311",
          "--heading-text-font-weight": "600",
          "--heading-text-font-family": "inherit",
          "--heading-text-line-height": "1.4",
          "--heading-text-letter-spacing": "0",
          "--heading-text-transform": "none",
          //Body text styles:
          "--body-text-color": "#0E1311",
          "--body-text-font-weight": "400",
          "--body-text-font-family": "inherit",
          "--body-text-line-height": "1.4",
          "--body-text-letter-spacing": "0",
          "--body-text-transform": "none",
          //Input field styles:
          "--inputfield-text-font-family": "inherit",
          "--input-text-font-size": "14px",
          "--inputfield-text-font-weight": "400",
          "--inputfield-text-color": "#0E1311",
          "--inputfield-border-color": "rgba(0,0,0,0.2)",
          "--inputfield-background-color": "transparent",
          "--inputfield-border-width": "1px",
          "--inputfield-border-radius": "0px",
          "--common-border-color": "rgba(0,0,0,0.15)",
          "--common-border-width": "1px",
          "--common-sidebar-width": "190px",
          //Slider indicator (for attributes) styles:
          "--slider-indicator-bg-color": "rgba(0,0,0,0.1)",
          "--slider-indicator-button-color": "#0E1311",
          "--slider-indicator-width": "190px",
          //Badge styles:
          "--badge-icon-color": "#0E1311",
          "--badge-icon-font-size": "inherit",
          "--badge-text-color": "#0E1311",
          "--badge-text-font-size": "inherit",
          "--badge-text-letter-spacing": "inherit",
          "--badge-text-transform": "inherit",
          //Author styles:
          "--author-font-size": "inherit",
          "--author-text-transform": "none",
          //Author avatar styles:
          "--avatar-thumbnail-size": "60px",
          "--avatar-thumbnail-border-radius": "100px",
          "--avatar-thumbnail-text-color": "#0E1311",
          "--avatar-thumbnail-bg-color": "rgba(0,0,0,0.1)",
          //Product photo or review photo styles:
          "--photo-video-thumbnail-size": "80px",
          "--photo-video-thumbnail-border-radius": "0px",
          //Media (photo & video) slider styles:
          "--mediaslider-scroll-button-icon-color": "#0E1311",
          "--mediaslider-scroll-button-bg-color": "rgba(255, 255, 255, 0.85)",
          "--mediaslider-overlay-text-color": "#FFFFFF",
          "--mediaslider-overlay-bg-color": "rgba(0, 0, 0, 0.8))",
          "--mediaslider-item-size": "110px",
          //Pagination & tabs styles (normal):
          "--pagination-tab-text-color": "#0E1311",
          "--pagination-tab-text-transform": "none",
          "--pagination-tab-text-letter-spacing": "0",
          "--pagination-tab-text-font-size": "16px",
          "--pagination-tab-text-font-weight": "600",
          //Pagination & tabs styles (active):
          "--pagination-tab-active-text-color": "#0E1311",
          "--pagination-tab-active-text-font-weight": "600",
          "--pagination-tab-active-border-color": "#0E1311",
          "--pagination-tab-border-width": "3px",
      },
    });
  }

  function loadScript(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.append(script);

    if (callback) {
      script.onload = function() { callback(); };
    }
  }

  function loadStyle(src) {
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = src;
    document.head.append(style);
  }
})();